import styled from 'styled-components/macro'

export const Bar = styled.div<{ loadingPercent?: Number; width: string; maxWidth: string }>`
  background: ${(props) => (props.loadingPercent ? `linear-gradient(90deg, #9542FF 0%, #3AD8ED 100%);` : `#38383D;`)};
  border-radius: 15px;
  width: ${(props) => (props.loadingPercent ? `${props.loadingPercent}%` : `${props.width}`)};
  height: 12px;
  max-width: ${(props) => `${props.maxWidth}`};
`